import React from 'react';
import { LightbulbIcon, CheckCircleIcon } from 'lucide-react';
export const Solution = () => {
  return <section className="mb-10" data-id="element-257">
      <div className="bg-blue-50 p-5 rounded-lg mb-8 border-l-4 border-blue-500" data-id="element-258">
        <h2 className="text-xl font-bold text-blue-800 flex items-center mb-4" data-id="element-259">
          <LightbulbIcon className="w-6 h-6 mr-2 text-blue-600" data-id="element-260" />
          De ontdekking die alles veranderde
        </h2>
        <p className="mb-4 leading-relaxed" data-id="element-261">
          Amee de Bruijn maakte haar doorbraak toen ze besefte dat het probleem
          niet lag bij de honden - maar bij onze interpretatie van hun gedrag.
        </p>
        <p className="mb-4 leading-relaxed" data-id="element-262">
          "Jarenlang probeerden we honden te leren om onze taal spreken," legt
          Amee uit. "Maar niemand nam de moeite om hun taal te leren. Het is
          alsof je naar Frankrijk verhuist en boos wordt omdat de locals geen
          Nederlands spreken."
        </p>
        <p className="text-lg font-semibold text-blue-800 mb-4" data-id="element-263">
          Haar onderzoek naar moderne hondencommunicatie onthulde iets
          verrassends: honden communiceren voornamelijk via lichaamstaal en
          subtiele signalen, niet via geblaf. Wanneer ze blaffen, piepen of
          andere "storende" gedragingen vertonen, is dat meestal het eindpunt
          van een hele reeks signalen die wij gemist hebben.
        </p>
      </div>
      <div className="w-full mb-6" data-id="element-264">
        <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/wMD9H36KPsrVSLkgoCNxr9/Scherm_afbeelding_2025-08-15_om_15.37.25-min.png" alt="Vrouw communiceert met haar hond in een park" className="w-full h-auto rounded-lg shadow-md" data-id="element-265" />
        <p className="text-xs text-gray-500 mt-1 text-center italic" data-id="element-266">
          "In 90 minuten kan ik mensen de basisgrammatica van de hondentaal
          leren," stelt Amee
        </p>
      </div>
      <h2 className="text-xl font-bold text-blue-800 mb-4" data-id="element-267">
        Leer de methode in dit gratis online webinar
      </h2>
      <p className="mb-6 leading-relaxed" data-id="element-268">
        Traditionele trainingsmethoden focussen op het veranderen van
        hondengedrag. Maar Amee's benadering is fundamenteel anders: in plaats
        van je hond te veranderen, leer je zijn taal begrijpen.
      </p>
      <p className="mb-6 leading-relaxed" data-id="element-269">
        "Het is als het leren van gebarentaal," legt ze uit. "Je leert hoe
        honden onderling elkaar subtiele signalen geven met hun lichaam. Aan
        deze signalen kan je zien wat ze voelen en willen. Ook leer je hoe je
        als mens deze signalen kan gebruiken zodat jouw hond dingen kan
        vertellen in zijn taal."
      </p>
      <ul className="mb-6 space-y-3" data-id="element-270">
        <li className="flex items-start" data-id="element-271">
          <CheckCircleIcon className="w-5 h-5 text-green-500 mr-2 mt-0.5 flex-shrink-0" data-id="element-272" />
          <span data-id="element-273">
            De vijf basis-signalen die elke hond gebruikt en wat ze betekenen
          </span>
        </li>
        <li className="flex items-start" data-id="element-274">
          <CheckCircleIcon className="w-5 h-5 text-green-500 mr-2 mt-0.5 flex-shrink-0" data-id="element-275" />
          <span data-id="element-276">
            Hoe je stress herkent voordat het escaleert naar probleemgedrag
          </span>
        </li>
        <li className="flex items-start" data-id="element-277">
          <CheckCircleIcon className="w-5 h-5 text-green-500 mr-2 mt-0.5 flex-shrink-0" data-id="element-278" />
          <span data-id="element-279">
            De drie grootste misverstanden die leiden tot frustratie bij beide
            partijen
          </span>
        </li>
        <li className="flex items-start" data-id="element-280">
          <CheckCircleIcon className="w-5 h-5 text-green-500 mr-2 mt-0.5 flex-shrink-0" data-id="element-281" />
          <span data-id="element-282">
            Direct toepasbare technieken om terug te communiceren in zijn taal
          </span>
        </li>
      </ul>
      <p className="mb-6 leading-relaxed" data-id="element-283">
        Maar het echte geheim zit in de volgorde waarin Amee deze kennis deelt.
      </p>
      <p className="mb-6 leading-relaxed" data-id="element-284">
        "Ik begin met de signalen die mensen het meest herkennen, maar verkeerd
        interpreteren," legt ze uit. "Zodra ze doorhebben dat veel van het
        dominante gedrag eigenlijk heel iets anders betekent, valt alles op zijn
        plaats. Dan zijn de overige signalen logische uitbreidingen."
      </p>
      <p className="mb-6 leading-relaxed" data-id="element-285">
        "Veel mensen vragen zich af of ze online wel iets over hun hond kunnen
        leren," grapt Amee. "Maar omdat hondentaal voor alle honden hetzelfde is
        kan ik je met voorbeeld video's en een goede presentatie al super veel
        leren over je eigen hond."
      </p>
      <p className="mb-6 leading-relaxed" data-id="element-286">
        "Honden zijn geen mysterieuze wezens," zegt Amee. "Hondentaal is
        subtiel, maar glashelden. Ze communiceren helder en consistent. Je moet
        alleen leren waar je naar moet kijken."
      </p>
    </section>;
};